export default {
  ['setVideos'](state, payload) {
    state.videos = [...state.videos, ...payload];
  },
  ['resetVideos'](state, payload) {
    state.videos = payload;
  },
  ['setAllVideosLoaded'](state, payload) {
    state.allVideosLoaded = payload;
  },
  ['setFilteredVideos'](state, payload) {
    state.filteredVideos = payload;
  },
  ['removeVideo'](state, payload) {
    state.videos = state.videos.filter((item) => item.id !== payload);
    state.totalVideos = state.totalVideos - 1;
  },
  ['setTotalVideos'](state, payload) {
    state.totalVideos = payload;
  },
  ['setCurrentFolderId'](state, payload) {
    state.currentFolderId = payload;
  },
  ['addSelectedVideo'](state, payload) {
    state.selectedVideos = [...state.selectedVideos, payload];
  },
  ['removeSelectedVideo'](state, payload) {
    state.selectedVideos = state.selectedVideos.filter((item) => item.id !== payload.id);
  },
  ['clearSelectedVideos'](state) {
    state.selectedVideos = [];
  },
}
